import styled from "styled-components";

export const HeaderWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const HeaderContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;

    @media only screen and (max-width: 600px) {
        flex-direction: column;
        justify-content: center;
    }
`;

export const TitlesWrapper = styled.div`
    @media only screen and (max-width: 600px) {
        text-align: center;
    }
`;

export const HeaderMainTitle = styled.div`
    color: rgba(172, 52, 33, 1);
    font-size: 33pt;
    text-transform: uppercase;
    font-family: "Proxima Nova Bold";

    @media only screen and (max-width: 800px) {
        font-size: 28pt;
    }

    @media only screen and (max-width: 600px) {
        font-size: 25pt;
    }
`;

export const HeaderSecondaryTitle = styled.div`
    font-size: 23pt;
    text-transform: uppercase;
    font-family: "Proxima Nova Bold";

    @media only screen and (max-width: 800px) {
        font-size: 18pt;
    }

    @media only screen and (max-width: 600px) {
        font-size: 15pt;
    }
`;

export const HeaderTernaryTitle = styled.div`
    color: #5E5E5E;
    font-size: 13pt;
    text-transform: uppercase;
    font-family: "Proxima Nova Bold";

    @media only screen and (max-width: 800px) {
        font-size: 8pt;
    }
`;

export const HeaderLogo = styled.img`
    margin-top: 1rem;

    @media only screen and (max-width: 800px) {
        height: 150px;
    }

    @media only screen and (max-width: 600px) {
        font-size: 125px;
    }
`;